import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Link from 'UIKit/Link'
import { RouteConfig } from 'config/constants/route'
import { RowBetween, RowCenter } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import { useUnwatchedNewBonusListener } from 'state/bonus/hooks'
import { useUserBonus } from 'state/bonus/hooks/useUserBonus'
import styled, { css } from 'styled-components'
import { StyledExtendMenuItem, StyledText, StyledTitle } from '../../style'

const BonusCenterMenu = () => {
  const { bonuses } = useUserBonus()
  const [unwatchedNewBonus, onClose] = useUnwatchedNewBonusListener()

  return (
    <StyledExtendMenuItem
      id="menu-bonusCenter"
      as={Link}
      href={RouteConfig.BonusCenter}
      borderRadius="4px !important"
      overflow="hidden"
      position="relative"
      onClick={onClose}
      data-tooltip-id={'bonus-menu'}
    >
      <RowBetween
        width="100%"
        height="44px"
        top="0px"
        position="absolute"
        px="8px"
        background="radial-gradient(101.24% 646.87% at 0.26% 100%,rgb(7 12 23 / 0%) 0%,#A60887 100%)
      "
      >
        <Flex justifyContent="center" alignItems="center" height="44px">
          <Box width="30px">
            <Image src="/images/bonus-center-gift.png" height={72} width={81} />
          </Box>
          <StyledTitle
            fontSize="14px !important"
            textTransform="uppercase"
            ml="4px"
            mt="2px"
            fontWeight="700 !important"
          >
            <Trans>BONUS CENTER</Trans>
          </StyledTitle>
        </Flex>

        <Box>
          {!!bonuses?.length && (
            <StyledBonusCenterBadge $isHaveNewBonus={unwatchedNewBonus}>
              <StyledText fontSize="10px" fontWeight={600}>
                {bonuses.length}
              </StyledText>
            </StyledBonusCenterBadge>
          )}
        </Box>
      </RowBetween>
    </StyledExtendMenuItem>
  )
}

const StyledBonusCenterBadge = styled(RowCenter)<{ $isHaveNewBonus: boolean }>`
  position: relative;
  background: ${({ theme: { colors } }) => colors.strokeAlt3};
  padding: 2px 4px;
  border-radius: 40px;

  min-width: 18px;
  min-height: 16px;

  ${({ $isHaveNewBonus }) =>
    $isHaveNewBonus &&
    css`
      @keyframes ping {
        0% {
          transform: scale(1);
          opacity: 0.5;
        }
        100% {
          transform: scale(2);
          opacity: 0;
        }
      }

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 40px;
        background: #fff;
        animation: ping 1.7s ease infinite;
        opacity: 0.25;
        z-index: 10;
      }
    `};
`

export default BonusCenterMenu
